import { useParams } from "react-router";
import RisikoanalyseStepForm from "./RisikoanalyseStepForm";

/**
 * Internal Beratermodus: opens the full step-based Risikoanalyse for an
 * advisor, fully integrated in the app — no public link, no token.
 *
 * Route: /contacts/:contactId/beratermodus
 *
 * Daten leben direkt auf Contact (jsonb-Spalten risikoanalyseAuswertungDraft*).
 * Vor der Migration vom Token-basierten Pfad weg liefen die Daten als
 * PublicFormToken mit formType='risikoanalyse-step' — Migration
 * 202605250001 zieht die Bestandsdaten rueber.
 */

const BeratermodusFormPage = () => {
  const { contactId } = useParams<{ contactId: string }>();
  const contactIdNum = contactId ? parseInt(contactId, 10) : NaN;

  if (!contactId || Number.isNaN(contactIdNum)) {
    return null;
  }

  return (
    <RisikoanalyseStepForm
      internalMode
      internalContactId={contactIdNum}
      welcomeStoragePrefix="risikoanalyse-berater-welcome-seen:"
      draftStoragePrefix="risikoanalyse-berater-draft:"
      submitVersion="berater-step-form-v1"
      internalReturnPath={`/contacts/${contactId}`}
    />
  );
};

export default BeratermodusFormPage;
